import React, {Component} from 'react';

import {dateSort, lastFilter} from './helperfunctions'
import { TitleRow, RowOfChildren, GridText, newSortIndicators, clearSortIndicators, coreSort,
        clickToTableTarget, clickToNamedClass, formatTable, setSortIndicator } from "./RenderHelpers";
import SecondServer from '../database/SecondServer'
import { siteAccessCode } from '../database/apiv2SiteAccessor'
import {fetchSourceDevices} from '../database/fetch'
import { fetchMdtConfig } from './Model/DeviceType';
import {Uncommissioned} from './Model/Uncommissioned'
import {csvDownload} from '../csv/csvExport'
import NoResults from '../Alert/NoResults'
import ButtonBar from './Controls/CommissionButton'
import FilterPanel from './Controls/FilterPanel'
import GridAction from './Controls/GridAction'
import CommissionChart from '../Chart/CommissionChart'
import { cachedPerms, canWrite } from "../Overview/SitePerms"
import { nestedProp } from '../Utils/object';
import DeviceEdit from "./Controls/DeviceEdit";
import { renderLoader } from "../Loading/loading";
import {between, sanitizeDateTime} from "../timeFunctions/timeFns"

// available reports
import jsonReportCfg from './reportcfg';
import './report.css'
import '../Decorators/Checkmarks.css'

export default class CommissionSensor extends Component {
  constructor(props) {
    super(props);

    this.reportId = "commission"
    let arrSort = newSortIndicators(jsonReportCfg.data[this.reportId].displayOrder.length);
    this.tableId = "dispTable";

    this.state = {
      report:  null,
      filterReport: null,
      allData: null,
      formatReport: null,
      config: jsonReportCfg,
      errorMsg: null,
      chartProps: null,
      endrange: new Date(),
      startrange: new Date(Date.now() - 24*3600 * 1000),
      lastSort: '', 
      colSort: arrSort,
      batteryFormat: 0,
      isLoading: true,
      loader: renderLoader(),
      deviceId: undefined,
      deviceConfig: undefined,
      chartShow: false,
      deviceToEdit: undefined,
    };
    this.deviceEditMap = [
      { from: "Apt", to: "apt" }, { from: "Building", to: "building" },
      { from: "NodeId", to: "node_id" }, {from: "address", to: "address"}
    ];

    this.sort = this.sort.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onEditHide = this.onEditHide.bind(this);
    this.filter = this.filter.bind(this)
    this.refresh = this.refresh.bind(this)
    this.readings = this.readings.bind(this)
   }

  async fetchData() {
    if (!this.state.isLoading) 
      this.setState({isLoading: true});

    const site = this.props.getActiveSite();
    const ss = new SecondServer(this.props);
    const jsonResponse = await fetchSourceDevices (site, ss)
    //console.log (jsonResponse)
    this.setState ( {errorMsg: ss.getErrorMsg() } );
    const allUncomm = Uncommissioned(jsonResponse)
    return allUncomm 
  }
  timeFilter(allUncomm) {
    const disp = allUncomm.filter(i=>i?.LatestData?.RXTime && 
      between(sanitizeDateTime(i?.LatestData?.RXTime, {locale: 'en-US', zone: 'UTC'}), this.state.startrange, this.state.endrange))
    return disp
  }
  setData(filteredResponse) {
    if (filteredResponse) {
      const displayCopy = this.timeFilter(filteredResponse.slice())
      const formatCopy = formatTable (displayCopy, "device_id", this.props.radioStyle);
      this.setState( {report: filteredResponse, filterReport: displayCopy, formatReport: formatCopy,} );
    }
    this.setState({isLoading: false})
  }

  async componentDidMount() {
    this.props.breadCrumb([{display:'Uncommissioned', click:undefined}, ])
    await this.refresh()
  }
  async componentDidUpdate(prevProps, prevState) {
    if (this.state.report && (prevState.startrange.getTime() !== this.state.startrange.getTime() || 
      prevState.endrange.getTime() !== this.state.endrange.getTime())) {
        this.setData(this.state.report)
    }
    if (this.props?.update && prevProps.update < this.props.update)
      this.componentDidMount()
    if (prevProps.radioStyle !== this.props.radioStyle) {
      this.setData(this.state.report)
    }
  }
  async refresh () {
    const resp = await this.fetchData();
    this.setData(resp);
  }
  consumption (modifiedResponse) {
    // sort readings by date
    const arrWorking = modifiedResponse.data.raw_data;
    const byDate = dateSort(arrWorking, "ReadTime");
    var lasts = lastFilter(byDate, "DeviceId");
    byDate.forEach(dev => {
      var index = lasts.findIndex(t => {
        return t.DeviceId === dev.DeviceId
      })
      dev.Consumed1 = dev.ReadVal1 - lasts[index].ReadVal1;
      dev.Consumed2 = dev.ReadVal2 - lasts[index].ReadVal2;
      dev.Consumed3 = dev.ReadVal3 - lasts[index].ReadVal3;
      //console.log (dev.DeviceId, dev.Consumed1, dev.ReadVal1, dev.ReadTime, lasts[index].ReadVal1, lasts[index].ReadTime);
    })
  }

  reverseOrder(targ) {
    var arrWorking = this.state.filterReport.slice(0);
    const revArr = arrWorking.reverse();
    const arrSort = setSortIndicator(targ, this.state.colSort);
    const display = formatTable (arrWorking, "device_id", this.props.radioFormat());
    this.setState ({filterReport: revArr, formatReport: display, colSort: arrSort});
  }

  //click handler for title row
  sort(e) {
    var targ = clickToTableTarget(e);
    if ("id" in targ)
    {
      const column = targ.id.trim();
      if (this.state.lastSort === column) {
        this.reverseOrder(targ);
        return;
      }
      const arrSort = setSortIndicator(targ, clearSortIndicators(this.state.colSort));
      const arrWorking = this.state.filterReport;
      coreSort (arrWorking, column)
      const display = formatTable (arrWorking, "device_id", this.props.radioFormat());
      this.setState ({filterReport: arrWorking, formatReport: display, lastSort: column, colSort: arrSort});
    }
  } 

  filter (which, panelState) {
    if (which === 'date') {
      this.setState({startrange:panelState.startTime, endrange:panelState.endTime})
      return
    }
    if (which === 'filter') {
      let arrFilter = this.state.report.slice(0);
      if (panelState?.length > 0) {
        const lsearch = panelState.toLowerCase();
        arrFilter = arrFilter.filter(item => Object.values(item).join().toLowerCase().includes(lsearch))
      }
      const display = formatTable (arrFilter, "device_id", this.props.radioFormat());
      this.setState({filterReport: arrFilter, formatReport: display});
    }
  }
  onEdit(evt) {
    const btn = clickToNamedClass(evt, "actButton");
    console.log(btn.className, btn.getAttribute("index"));
    this.setState({ deviceToEdit: btn.getAttribute("index"), editModal: true });
  }
  async onEditHide() {
    this.setState({ deviceToEdit: undefined, editModal: false });
    this.refresh()
  }
  visibleData() {
    const s = this.state
    return s.formatReport? s.formatReport : s.filterReport
  }
  async readings (evt) {
    const btn= clickToNamedClass(evt, "actButton")
    const index = btn.getAttribute('index')
    const tableData = this.visibleData()
    const deviceId = tableData[index].device_id
    const site = this.props.getActiveSite()
    const ss = new SecondServer(this.props)   // cache lacks uncomissioned devices
    const cfg = await fetchMdtConfig (ss, siteAccessCode(site), deviceId)
    this.setState({deviceId: deviceId, deviceConfig: cfg?.devices[0], chartShow: true})
  }
  showTable() {
    if (this.state.isLoading) {
      return this.state.loader
    }
    if (this.state.filterReport && this.state.filterReport.length === 0) {
      return (<NoResults displayText="No uncommissioned devices found."/>);
    }
    const rawData = this.visibleData()
    const reportId = this.reportId; /// props.location.pathname.split("/").pop();
    const colSeq = this.state.config.data[reportId].displayOrder;
    const colNames = this.state.config.data[reportId].displayName;
    const textCols = [0,1,2,3,4,5,6,7]
    return(
      <table className="csv-table" id={this.tableId}>
        <tbody>
        <TitleRow index={0} data={rawData[0]} colName={colNames} colSeq={colSeq} graph={this.sort} colSort={this.state.colSort}/>
        {rawData.map((dev, index) =>
          <RowOfChildren id={index} key={index}>
            {textCols.map(i=> (<GridText value={nestedProp(dev, colSeq[i])} key={i}/>))}
            <GridAction id='action' index={index}  key="act"
              onChart={this.readings} onEdit={this.onEdit} />
          </RowOfChildren>
        )}
        </tbody>
      </table>
    );
  }
  fakeSensorsToChart() {
    const result = this.state.deviceConfig
    if (result.sensors.length === 0) {
      const fakeSensor = {sensor_type:'*', factor:1, initial_meter_read:0}
      result.sensors.push(fakeSensor)
      result.sensors.push(fakeSensor)
    }
    return result
  }
  showChart() {
    const st = this.state
    const device = this.fakeSensorsToChart()
    //const sensors = this.sensorTypes()
    const deviceMeta = {units1: device?.sensors[0]?.units ?? '', 
      units2: device?.sensors[1]?.units ?? '',
      Type: device?.type ?? 'MDT', 
      sensorType: device.sensors[0]?.display_type ?? '*',
      sensorType2: device.sensors[1]?.display_type ?? '*'}
    const chartProps = {radioId: st.deviceId, apiParams: 'SensorData',
       ...deviceMeta, deviceMeta: deviceMeta }
    return (
      <CommissionChart show={st.modalShow} hide={()=>this.toggleChart(0)} 
        chartProps={chartProps} {...this.props} noUpdates={true} deviceConfig={device}
        startrange={st.startrange} endrange={st.endrange} singleBlock={false} />
    )
  }
  canEdit() {
    return canWrite(cachedPerms(this.props.getActiveSite()))
  }
  buttonBar() {
    return (
      this.canEdit() ? 
        <ButtonBar {...this.props} csvClick={csvDownload} csvTable={this.tableId} onUpdate={this.refresh}/>
         : null
    )
  }
  showControls () {
    return this.state.chartShow ? null: (
      <FilterPanel {...this.props} propagateState={this.filter}>
        {this.buttonBar()}
      </FilterPanel>
    )
  }
  showContent () {
    return this.state.chartShow ? this.showChart() : this.showTable()
  }
  render() {
    const table = this.visibleData()
    const editData = this.state.deviceToEdit ? table[this.state.deviceToEdit] : undefined;
    return (
      <div className="container-fluid">
        {this.showControls()}
        <DeviceEdit {...this.props} deviceId={editData?.device_id} onHide={this.onEditHide}
          show={this.state.editModal} objMap={this.deviceEditMap} meta={editData} mdtOnly='true'/>
       <div className="table-container">
          {this.showContent()}
        </div>
      </div>
    )
  }
}
